import { NgModule } from '@angular/core';
import { HostService } from './_generated/host.service';
import { SupportApiService } from './_internal/index';

@NgModule({
  imports: [],
  providers: [SupportApiService, HostService],
  declarations: [],
  exports: [],
})
export class SupportModule {}
